import React from 'react';
import { GrLinkedin, GrGithub } from "react-icons/gr";
import { AiFillInstagram } from "react-icons/ai";

const Footer = () => {
  const dateNow = new Date();

  const [darkToggle, setDarkToggle] = React.useState(false)
    return (
        <footer className={`p-8 bg-blue-500 font-bold text-white rounded`}>
        <div className=''>
          <div className="flex flex-row justify-center gap-x-4 text-xl">
            <a href="https://www.linkedin.com/in/fhatuwani-raphalalani-51bb98172/" target="_blank">
              <GrLinkedin style={{ fill: "#fff" }} />
            </a>
            <a href="https://github.com/BigguyFM98000/" target="_blank">
              <GrGithub style={{ fill: "#fff" }} />
            </a>
            <a href="https://www.instagram.com/raphalalani_fhatuwani/" target="_blank">
              <AiFillInstagram style={{ fill: "#fff" }} />
            </a>
          </div>
        </div>
        <div className="flex justify-center flex-row p-2">
          <p className="text-center text-white text-xl">
            Copyright © {dateNow.getFullYear()} - Created by Fhatuwani Raphalalani
          </p>
        </div>
      </footer>
    )
}

export default Footer;
